import PlanLimitsUsersController from './planLimitsUsersController';

export default class ModalService {
  [x: string]: any;

  static $inject = ['$modal', '$q', '$window', 'TransferData'];

  constructor($modal, $q, $window, TransferData) {
    this.message = {};
    this.modal = $modal;
    this.$q = $q;
    this.$window = $window;
    this.TransferData = TransferData;
  }

  showModalConfirm(message) {
    return this.showModal(message, true);
  }

  showUpgradeAccountModal() {
    return this.showModal({
      title: "TRIAL_MODAL.TITLE",
      body: "TRIAL_MODAL.TEXT",
      confirm: "TRIAL_MODAL.CONFIRM",
    }, true).then(() => {
      this.router.navigateByUrl("/my-account")
    })
  }

  showChannelsWarningModal(message: ChannelsNg1ModalParams, withGoBack: boolean, templateUrl = 'channelsWarningModal.html') {
    let defer = this.$q.defer();
    const window = this.$window;
    this.modal({
      template: require(`./${templateUrl}`),
      controller: function() {
        this.message = message;
        this.confirm = confirm;
        this.cancel = () => {
          if(withGoBack){
            window.history.back();
          }
          return defer.reject();
        };
      },
      controllerAs: '$ctrl'
    });
    return defer.promise;
  }


  showModal(message, confirm, templateUrl = 'modal.html') {
    let defer = this.$q.defer();
    this.modal({
      template: require(`./${templateUrl}`),
      /*@ngInject*/
      controller: [
        'LiveChat',
        function(LiveChat) {
          this.message = message;
          this.confirm = confirm;
          this.LiveChat = LiveChat;
          this.success = () => {
            document.body.classList.remove('modal-open'); // work around a bug in angular-strap
            defer.resolve();
          };
          this.cancel = () => {
            defer.reject();
            document.body.classList.remove('modal-open'); // work around a bug in angular-strap
          };
          this.contactSupport = () => this.LiveChat.contactSupport();
        }
      ],
      controllerAs: '$ctrl'
    });
    return defer.promise;
  }

  showAddToBlacklistModal(numbers) {
    let defer = this.$q.defer();
    this.modal({
      template: require('./addToBlacklist.html'),
      /*@ngInject*/
      controller: function() {
        this.numbers = numbers;
        this.success = () => defer.resolve(this.selectedNumbers);
        this.cancel = () => defer.reject();
        this.onSelect = number => {
          number.selected = !number.selected;
          this.selectedNumbers = this.numbers.filter(number => number.selected);
        };
      },
      controllerAs: '$ctrl'
    });
    return defer.promise;
  }

  showPlanLimitUsersModal(title, description, userList, userLimit) {
    let defer = this.$q.defer();
    this.TransferData.setArguments(Object.assign(arguments, { defer: defer }));
    this.modal(PlanLimitsUsersController);
    return defer.promise;
  }
}

export interface ChannelsNg1ModalParams {
  title: string;
  body: string;
  buttonText: string;
}
